import css from '@styled-system/css';
import { ThemeStyles } from '@honda-canada/design-system-react';
const themeStyles = new ThemeStyles();
const cardMarginTop = '32px';
const cardExpandedMinHeight = '500px';
const navbarHeight = '100px';
const footerHeight = '95px';
const cardExpandedMaxDesiredHeight = `max(100dvh - ${navbarHeight} - ${footerHeight} - (2 * ${cardMarginTop}), ${cardExpandedMinHeight})`;
themeStyles.addBaseStyles('SummaryCardComponent')(({ stickyOffsetTop }) => css({
    position: ['static', 'sticky', 'sticky'],
    top: `calc(${stickyOffsetTop}px + ${cardMarginTop})`,
    width: ['auto', 'auto', '485px'],
}));
themeStyles.addBaseStyles('SummaryCardWrapper')(({ isExpanded }) => css({
    display: isExpanded ? ['', '', 'flex'] : '',
    flexDirection: isExpanded ? ['', '', 'column'] : '',
    alignItems: isExpanded ? ['', '', 'stretch'] : '',
    borderRadius: '8px',
    maxHeight: ['570px', '570px', isExpanded ? 'none' : '570px'],
    px: '20px',
    py: ['default', 'default', '20px'],
    mt: `${cardMarginTop}`,
    mb: [`${cardMarginTop}`, `${cardMarginTop}`, isExpanded ? 'zero' : `${cardMarginTop}`],
    ml: ['0', '0', '30px'],
    backgroundColor: 'white',
    minWidth: ['100%', '100%', '455px'],
}));
themeStyles.addBaseStyles('SummaryCardHeaderWrapper')(css({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    pb: ['m', 'm', 'default'],
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'grey.3',
}));
themeStyles.addBaseStyles('SummaryCardPaymentWrapper')(css({
    display: 'grid',
    placeContent: 'center',
    gridTemplateColumns: 'repeat(auto-fit, minmax(0px, max-content))',
    gridTemplateRows: '100%',
    gap: ['xs', 'm', 'm'],
    py: ['default', 'default', '24px'],
    borderBottomWidth: '1px',
    borderBottomStyle: 'solid',
    borderBottomColor: 'grey.3',
}));
themeStyles.addBaseStyles('ModelBadge')(css({
    height: '15px',
    width: '135px',
    mb: 'xs',
    objectFit: 'contain',
    marginX: '0',
    objectPosition: 'left',
}));
themeStyles.addBaseStyles('PriceContainer')(css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'xxs',
    px: ['10px', '10px', '21px'],
}));
themeStyles.addBaseStyles('PriceInfo')(css({
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    columnGap: 'xs',
    width: '100%',
}));
themeStyles.addBaseStyles('TermContainer')(css({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'xs',
    px: ['xs', '20px', '20px'],
}));
themeStyles.addBaseStyles('SummaryCardImage')(({ isExpanded }) => css({
    width: isExpanded ? ['145px', '145px', 'auto'] : ['145px', '145px', '198px'],
    maxWidth: isExpanded ? ['none', 'none', '100%'] : 'none',
    maxHeight: [
        'auto',
        'auto',
        isExpanded ? `calc(max(min(0.25 * ${cardExpandedMaxDesiredHeight}, 200px), 80px) + 30px)` : '100px',
    ],
    alignSelf: 'center',
    mb: ['xs', 'xs', '0'],
    mx: 'auto',
}));
themeStyles.addBaseStyles('SummaryCardInfoWrapper')(({ isExpanded }) => css({
    display: 'flex',
    flexDirection: isExpanded ? 'column' : ['column', 'column', 'row-reverse'],
    pt: ['m', 'm', 'default'],
    flexGrow: isExpanded ? ['0', '0', '1'] : '0',
    justifyContent: 'space-between',
    alignItems: isExpanded ? 'flex-start' : ['flex-start', 'flex-start', 'center'],
}));
themeStyles.addBaseStyles('SummaryCardCTA')(css({
    alignItems: 'center',
    minHeight: '22px',
    width: 'max-content',
    maxWidth: '100%',
    display: 'grid!important',
    gridTemplateColumns: '22px 1fr 8px',
    gap: '8px',
}));
themeStyles.addBaseStyles('SummaryCardCTAs')(({ isExpanded }) => css({
    maxWidth: ['100%', '100%', isExpanded ? '100%' : '50%'],
}));
themeStyles.addBaseStyles('CopyParagraph')(css({
    wordBreak: 'break-all',
}));
themeStyles.addBaseStyles('VerticalDivider')(({ theme }) => css({
    height: '100%',
    width: '1px',
    margin: 0,
    backgroundColor: theme.colors.grey[3],
}));
export default themeStyles;
